import React, { useState, useRef } from 'react';
import styles from './styles.module.scss';
import { BsFillBackspaceFill } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import routes from '../../routes/routes';
import { Menu } from '../../components/Menu/Menu';
import { digits } from '../../utils/digits';

export function DialerPage() {
  const navigate = useNavigate();
  const inputRef = useRef(null);

  const [phoneNumber, setPhoneNumber] = useState('');

  const numberDialHandler = e => {
    if (phoneNumber.length >= 12) return;

    const input = inputRef.current;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const newDigit = e.currentTarget.id;

    const newValue = phoneNumber.slice(0, start) + newDigit + phoneNumber.slice(end);
    setPhoneNumber(newValue);
    setTimeout(() => {
      input.setSelectionRange(start + 1, start + 1);
    }, 0);
  };

  const keyboardHandler = e => {
    setPhoneNumber(e.target.value);
  };

  const backspaceHandler = () => {
    const input = inputRef.current;
    const start = input.selectionStart;
    const end = input.selectionEnd;

    if (start !== end) {
      const newValue = phoneNumber.slice(0, start) + phoneNumber.slice(end);
      setPhoneNumber(newValue);
      setTimeout(() => {
        input.setSelectionRange(start, start);
      }, 0);
    } else if (phoneNumber.length > 0 && start > 0) {
      const newValue = phoneNumber.slice(0, start - 1) + phoneNumber.slice(start);
      setPhoneNumber(newValue);
      setTimeout(() => {
        input.setSelectionRange(start - 1, start - 1);
      }, 0);
    }
  };

  const handleCall = () => {
    if (phoneNumber === '') return;

    navigate(routes.OutgoingCallPage.path, {
      replace: true,
      state: phoneNumber,
    });
  };

  return (
    <main className={styles.mainWrapper}>
      <div className={styles.displayNumber}>
        <input
          type="text"
          autoFocus
          ref={inputRef}
          value={phoneNumber}
          className={styles.keyboardInput}
          onChange={keyboardHandler}
        />

        <div className={styles.backspace} onClick={backspaceHandler}>
          {phoneNumber.length > 0 ? <BsFillBackspaceFill /> : ''}
        </div>
      </div>

      <div className={styles.divider} />

      <div className={styles.dialPad}>
        {digits.map((digit) => (
          <div
            className={styles.dialNumber}
            id={digit.number}
            key={digit.number}
            onClick={numberDialHandler}
          >
            <div className={styles.number}>{digit.number}</div>
            <div className={styles.text}>{digit.text}</div>
          </div>
        ))}
      </div>

      <div className={styles.call}>
        <button className={styles.callButton} onClick={handleCall}>
          <img src="https://judite.olx.com.br/Phone.svg" alt="Phone" />
        </button>
      </div>

      <Menu state="Teclado" />
    </main>
  );
}